import { Grid, Typography, Box, Divider } from "@mui/material";
import { convertToPeriodTime, getPeriodName } from "./utils";

/**
 * Displays a list of events with timestamps grouped by hockey periods
 */
export default function EventsList({ events = [] }) {
  const groupedEvents = events.reduce((acc, event) => {
    const period = getPeriodName(event.time);

    if (!acc[period]) {
      acc[period] = [];
    }

    acc[period].push(event);
    return acc;
  }, {});

  const periodOrder = ["1st", "2nd", "3rd", "OT"];
  console.log("------ groupedEvents ------", groupedEvents);
  const sortedPeriods = Object.keys(groupedEvents).sort(
    (a, b) => periodOrder.indexOf(a) - periodOrder.indexOf(b)
  );

  return (
    <Box
      sx={{
        height: "600px",
        overflow: "auto",
        pr: 1,
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#555",
        },
      }}
    >
      {sortedPeriods.map((period) => (
        <Box key={period} sx={{ mb: 3 }}>
          <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
            {period} Period
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {groupedEvents[period].map((event, index) => (
            <Grid
              container
              key={`${event.name}-${period}-${index}`}
              sx={{ my: 1 }}
            >
              <Grid item xs={2}>
                <Typography variant="caption" color="text.secondary">
                  {convertToPeriodTime(event.time)}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Grid container spacing={0}>
                  <Grid item xs={10}>
                    <Typography variant="h6" color="text.secondary">
                      {event.name} {event.event.toUpperCase()}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant="subtitle1" color="text.secondary">
                      +{event.points}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="caption" color="text.secondary">
                      {event.matchName}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Box>
      ))}
    </Box>
  );
}
